<template>
  <b-form class="col-md-12">
    <b-row>
        <b-col sm="12">
          <b-alert v-if="FormCompleted" show variant="primary">Bahagian ini telah lengkap. ✔</b-alert>
          <b-alert v-else show variant="warning">Bahagian ini tidak lengkap.</b-alert>
          <hr />
        </b-col>
      </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group label="Bank" label-for="Bank">
          <template v-slot:label>
              Bank
              <span v-if="BankId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
          <b-form-select id="Bank"  v-model="BankId">
            <DefaultOption />
            <option
              v-for="item in Banks"
              v-bind:value="item.Id"
              :key="item.Id"
            >{{ item.Name | titleCase }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group v-if="BankId == 23" label-for="BankNameOther">
          <template v-slot:label>
              Nama Bank (Bank di dalam Malaysia Sahaja) 
              <span v-if="!BankNameOther" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
          <b-form-input
            id="BankNameOther"
            type="text"
            placeholder="Cth: RHB Bank"
            autocomplete="bankname"
             v-model.trim="BankNameOther"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-form-group label-for="BankAccountNo">
          <template v-slot:label>
              No Akaun Bank
              <span v-if="!AccountNo" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
          <b-form-input
            id="BankAccountNo"
            type="text"
            maxlength="20"
            placeholder="Cth: 155047512"
            autocomplete="bankaccountno"
             v-model.trim="AccountNo"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label-for="BankAccountNo">
          <template v-slot:label>
          <strong>
            <h5>
              NOMBOR AKAUN BANK INI AKAN DIGUNAKAN BAGI TUJUAN BAYARAN PINJAMAN. SILA PASTIKAN SALINAN PENYATA BANK YANG DI HANTAR ADALAH SAMA SEPERTI MAKLUMAT NOMBOR AKAUN BANK SEMASA PERMOHONAN INI DIBUAT.
            </h5>
          </strong>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>          

<script>
import DefaultOption from "./DefaultOption";

export default {
  name: "BankDetails",
  components: {
    DefaultOption
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.GetBankDetails();
      this.BankId = 0;
      this.AccountNo = "";
    }
  },
  computed: {
    FormCompleted: {
      get: function() {
        let complete = true;
        if (
          !this.AccountNo ||
          this.BankId == 0
        ) {
          complete = false;
        }

        //if (!this.BankId && !this.AccountNo) complete = false;

        this.$store.dispatch(
          "appBankDetails/updateFormCompleted",
          complete
        );
        return complete;
      }
    },
    BankId: {
      get: function() {
        return this.$store.getters["appBankDetails/BankId"];
      },
      set: function(value) {
        this.$store.dispatch("appBankDetails/updateBankId", value);
      }
    },
    BankNameOther: {
      get: function() {
        return this.$store.getters["appBankDetails/BankNameOther"];
      },
      set: function(value) {
        this.$store.dispatch("appBankDetails/updateBankNameOther", value);
      }
    },
    AccountNo: {
      get: function() {
        return this.$store.getters["appBankDetails/AccountNo"];
      },
      set: function(value) {
        this.$store.dispatch("appBankDetails/updateAccountNo", value);
      }
    },

    // Common
    Banks: {
      get: function() {
        return this.$store.getters["common/Banks"];
      }
    }
  },
  methods: {
    GetBankDetails() {
      return this.$API
        .get(this.$BankDetails, { withCredentials: true })
        .then(response => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.BankId = this.info.BankId;
            this.BankNameOther = this.info.BankNameOther;
            this.AccountNo = this.info.AccountNo;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    }
  }
};
</script>
